import React, { useEffect } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import axios from 'axios'
import setAuthToken from './utils/setAuthToken'
import checkAuth from './utils/checkAuth'
import logs from './utils/logs'

//Defis
import Login from './components/Login/LoginNovo'
import Nav from './components/Nav/NavNovo'
import Content from './components/Content/Content'
//Ética
import LoginEtica from './componentsEtica/Login/LoginEtica'
import NavEtica from './componentsEtica/Nav/NavEtica'
import ContentEtica from './componentsEtica/ContentEtica/ContentEtica'
import './App.css'
//Jurídico
import NavJuridico from './componentsJuridico/Nav/NavJuridico'
import LoginJuridico from './componentsJuridico/Login/LoginJuridico'
import ContentJuridico from './componentsJuridico/ContentJuridico/ContentJuridico'

if (window.location.pathname.slice(1, 6) === "etica") {
  if (localStorage.tokenY) {
    setAuthToken(localStorage.tokenY, "etica")
    checkAuth("/api/authEtica/checkAuth")
  }
}if (window.location.pathname.slice(1, 9) === "juridico") {
  if (localStorage.tokenJ) {
    setAuthToken(localStorage.tokenJ, "juridico")
    checkAuth("/api/authJuridico/checkAuth")
  }
} else {
  if (localStorage.token) {
    setAuthToken(localStorage.token, "defis")
    checkAuth("/api/auth/checkAuth")
  }
}

function App() {
  window.addEventListener('beforeprint', () => {
    window.scrollTo(0, 0)
  })
  const isInIframe = window.self !== window.top

  if (window.location.pathname.slice(1, 6) === "etica") {
    if (!localStorage.tokenY) {
      return <LoginEtica />
    }


    return (
      <div className="App">
        <Router>
          <NavEtica />
          <ContentEtica />
        </Router>
      </div>
    )
  }
  if (window.location.pathname.slice(1, 9) === "juridico") {
    if (!localStorage.tokenJ) {
      return <LoginJuridico />
    }


    return (
      <div className="App">
        <Router>
          <NavJuridico />
          <ContentJuridico />
        </Router>
      </div>
    )
  }

  else {
    if (!localStorage.token) {
      return <Login />
    }

    return (
      <div className="App">
        <Router>
          {!isInIframe && <Nav />}
          <Content />
        </Router>
      </div>
    )
  }
}

export default App
